// Marking a lead lost, confirmed. Simpler than converting — 'lost' carries no stage
// gate and no side effects — but it still drops the row off the pipeline for good, so
// the dialog names that consequence rather than asking "are you sure".
//
// It also states plainly that there is no way back from the interface, which is
// currently true: the Leads screen lists only pipeline stages, and the Clients screen
// shows stage as a read-only column.
import { useState } from 'react';
import { clientsApi } from '../../api';
import he from '../../i18n/he';
import Modal from '../../components/Modal';
import { ErrorText } from '../../components/Loader';

export default function MarkLostModal({ lead, onClose, onDone }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  // On success the parent closes this modal, so `busy` is cleared on the error path
  // only — leaving it set keeps the button dead while the reload runs.
  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await clientsApi.advanceStage(lead.id, 'lost');
      onDone();
    } catch (e) {
      setError(e);
      setBusy(false);
    }
  };

  return (
    <Modal
      title={he.leads.markLost}
      onClose={onClose}
      onSave={submit}
      saveLabel={he.leads.markLost}
      saveDisabled={busy}
    >
      <p className="convert-name">{lead.name}</p>
      <p>{he.leads.lostBody}</p>
      {error && <ErrorText error={error} />}
    </Modal>
  );
}
